import React, { useMemo, useRef, useState } from 'react';
import { Box, Typography, Paper } from '@mui/material';

function Sparkline({ data = [], height = 28, width = 140, stroke = '#1976d2', fill = 'rgba(25,118,210,0.12)', showTooltip = true }) {
  const containerRef = useRef(null);
  const [hoverIdx, setHoverIdx] = useState(null);

  const { step, points, area, max } = useMemo(() => {
    if (!data.length) {
      return { step: 0, points: '', area: '', max: 1 };
    }
    const maxVal = Math.max(...data.map(d => d.count), 1);
    const st = width / Math.max(data.length - 1, 1);
    const pts = data.map((d, i) => `${i * st},${height - (d.count / maxVal) * height}`).join(' ');
    const ar = `0,${height} ${pts} ${width},${height}`;
    return { step: st, points: pts, area: ar, max: maxVal };
  }, [data, height, width]);

  if (!data.length) return null;

  const handleMove = (e) => {
    if (!showTooltip || !containerRef.current) return;
    const rect = containerRef.current.getBoundingClientRect();
    const x = e.clientX - rect.left;
    const idx = Math.max(0, Math.min(data.length - 1, Math.round(x / Math.max(step, 1))));
    setHoverIdx(idx);
  };

  const handleLeave = () => setHoverIdx(null);

  const hover = hoverIdx != null ? data[hoverIdx] : null;
  const hoverX = hoverIdx != null ? hoverIdx * step : 0;
  const hoverY = hoverIdx != null ? height - (data[hoverIdx].count / Math.max(max, 1)) * height : 0;

  return (
    <Box sx={{ position: 'relative', display: 'inline-block' }} onMouseMove={handleMove} onMouseLeave={handleLeave}>
      <Box ref={containerRef} component="svg" width={width} height={height} viewBox={`0 0 ${width} ${height}`} sx={{ display: 'block' }}>
        <polyline points={points} fill="none" stroke={stroke} strokeWidth="2" strokeLinejoin="round" strokeLinecap="round" />
        <polygon points={area} fill={fill} />
        {hover && (
          <>
            <line x1={hoverX} y1={0} x2={hoverX} y2={height} stroke={stroke} strokeOpacity={0.3} />
            <circle cx={hoverX} cy={hoverY} r={2.5} fill={stroke} />
          </>
        )}
      </Box>
      {showTooltip && hover && (
        <Paper elevation={3} sx={{ position: 'absolute', left: Math.min(Math.max(hoverX - 30, 0), width - 80), top: -42, p: 0.5, px: 1, borderRadius: 1 }}>
          <Typography variant="caption" sx={{ display: 'block' }}>{hover.date}</Typography>
          <Typography variant="caption" sx={{ fontWeight: 700 }}>{hover.count} req</Typography>
        </Paper>
      )}
    </Box>
  );
}

export default Sparkline;


